export const GET_ASSET_TRANSACTIONS_LOADING = 'GET_ASSET_TRANSACTIONS_LOADING';
export const GET_ASSET_TRANSACTIONS_SUCCESS = 'GET_ASSET_TRANSACTIONS_SUCCESS';
export const GET_ASSET_TRANSACTIONS_ERROR= 'GET_ASSET_TRANSACTIONS_ERROR';